import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { NOME_MARCA } from "../../../../../environments/environment";
import { ConversaoLibraConverte } from "../../../../shared/conversao-libra/conversao-libra-converte";
import { Filtros } from "../../../../shared/crud/Filtro/Filtros";
import { ListaBase } from "../../../../shared/crud/ListaBase";
import { Parametro } from "../../../../shared/service-base/parametro";
import { PaServiceService } from "../pa-service.service";

@Component({
  selector: "app-pa-lista",
  templateUrl: "./pa-lista.component.html",
  styleUrls: ["./pa-lista.component.css"],
})
export class PaListaComponent extends ListaBase implements OnInit {
  spnv = 0;
  spnvTotal = 0;
  spnvAcessorio = 0;
  spnvPeca = 0;
  spnvClothing = 0;
  acessorio = 0;
  peca = 0;
  marca = NOME_MARCA

  valorPecasBalcao = 0;
  valorPecasServico = 0;
  valorAcessoriosBalcao = 0;
  valorAcessoriosServico = 0;
  valorTotal = 0;
  valorGarantia = 0;
  valorCPR = 0;
  quantidadeVeiculoVendido = 0;
  quantidadeVeiculoVendidoTotal = 0;
  valorClothing = 0;

  veiculosVendidos: string;
  acessoriosVeicVendidos: string;
  pecasVeicVendidos: string;
  clothingVeicVendidos: string;

  subscription;

  dadosTranslate = {
    "Motos Vendidas": "pca.resultadoPCA.motosVendidas",
    "Acessórios/Motos Vendidas": "pca.resultadoPCA.acessoriosMotosVendidas",
    "Peças/Motos Vendidas": "pca.resultadoPCA.pecaMotosVendidas",
    "Clothing/Motos Vendidas": "pca.resultadoPCA.clothingMotosVendidas",
    "Carros Vendidos": "pca.resultadoPCA.carrosVendidos",
    "Acessórios/Carros Vendidos": "pca.resultadoPCA.acessoriosCarrosVendidos",
    "Peças/Carros Vendidos": "pca.resultadoPCA.pecaCarrosVendidos",
    "Clothing/Carros Vendidos": "pca.resultadoPCA.clothingCarrosVendidos",
  };

  constructor(
    service: PaServiceService,
    toastr: ToastrService,
    router: Router,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte
  ) {
    super(service, toastr, router);
    this.nomeModulo = "P&A";

    if (this.marca.includes("Triumph") || this.marca.includes("Harley")) {
      this.veiculosVendidos = "Motos Vendidas";
      this.acessoriosVeicVendidos = "Acessórios/Motos Vendidas";
      this.pecasVeicVendidos = "Peças/Motos Vendidas";
      this.clothingVeicVendidos = "Clothing/Motos Vendidas";
    } else if (this.marca.includes("Volvo") || this.marca.includes("Porsche") || this.marca.includes("Stuttgart") || this.marca.includes("GWM") || this.marca.includes("BYD") || this.marca.includes("NBS")) {
      this.veiculosVendidos = "Carros Vendidos";
      this.acessoriosVeicVendidos = "Acessórios/Carros Vendidos";
      this.pecasVeicVendidos = "Peças/Carros Vendidos";
      this.clothingVeicVendidos = "Clothing/Carros Vendidos";
    }
  }

  ngOnInit() {
    this.buscar();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange.subscribe(
      (_event: LangChangeEvent) => {
        this.buscar();
      }
    );
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  protected getListagemComFiltros(): boolean {
    return (
      this.filtros.mercado ||
      this.filtros.grupo_economico ||
      this.filtros.regiao ||
      this.filtros.regional ||
      this.filtros.dealer ||
      this.filtros.data_inicial ||
      this.filtros.data_final
    );
  }

  getDados(response: any): any {
    this.spnvTotal = response.spnv;
    return this.carregarMarcas(response["marcas"]);
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }

    this.service.listar([], objFiltro).then((itens) => {
      this.carregarMarcas(itens["marcas"]);
    });
  }

  carregarMarcas(lista: any[]): any {
    lista.forEach((element) => {
      this.valorPecasBalcao = element.pecasBalcao;
      this.valorPecasServico = element.pecasServico;
      this.valorAcessoriosBalcao = element.acessoriosBalcao;
      this.valorAcessoriosServico = element.acessoriosServico;
      this.valorTotal =
        element.pecasBalcao +
        element.pecasServico +
        element.acessoriosBalcao +
        element.acessoriosServico +
        element.clothing +
        element.valorGarantia;
      this.valorGarantia = element.valorGarantia;
      this.valorCPR = this.valorTotal - element.valorGarantia;
      this.spnv = element.spnv;
      this.quantidadeVeiculoVendido = element.quantidadeVeiculoVendido;
      this.spnvPeca = element.spnvPeca;
      this.acessorio = element.acessoriosBalcao + element.acessoriosServico;
      this.valorClothing = element.clothing;
      this.spnvClothing = element.spnvClothing;

      this.converteLibras();
    });
    return lista;
  }

  converteLibras() {
    this.valorAcessoriosBalcao = this.conversaoLibraConverte.conversaoLibra(
      this.valorAcessoriosBalcao,
      null,
      null
    );
    this.valorAcessoriosServico = this.conversaoLibraConverte.conversaoLibra(
      this.valorAcessoriosServico,
      null,
      null
    );
    this.valorPecasBalcao = this.conversaoLibraConverte.conversaoLibra(
      this.valorPecasBalcao,
      null,
      null
    );
    this.valorPecasServico = this.conversaoLibraConverte.conversaoLibra(
      this.valorPecasServico,
      null,
      null
    );
    this.valorGarantia = this.conversaoLibraConverte.conversaoLibra(
      this.valorGarantia,
      null,
      null
    );
    this.valorClothing = this.conversaoLibraConverte.conversaoLibra(
      this.valorClothing,
      null,
      null
    );
    this.valorTotal = this.conversaoLibraConverte.conversaoLibra(
      this.valorTotal,
      null,
      null
    );
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }
}
